import { Divider } from 'antd';
import editIcon from '../../../../assets/editAdminIcon.svg';
import messageGrey from '../../../../assets/messageGrey.svg';
import './index.scss';

export const SupplierCardForTR = ({ elem, setIsEditModal, setSupplierData, setTaskId, isAward = false }: any) => {
    return (
        <div className="task-complete__supplier supplier supplier-card-tr">
            <div className="supplier__header newdesign">
                <div className="supplier-tags">
                    <div className="supplier-tags__left">
                        {elem.added_by_bayer && <span className="tag tag--buyer">Added by buyer</span>}

                        {elem.incumbent && <span className="tag tag--incumbent">Incumbent Supplier</span>}
                    </div>
                </div>
                {elem.status === 'shortlisted' && (
                    <div className="supplier-tags__status">{isAward ? 'Awarded' : 'Shortlisted'}</div>
                )}
                {elem.status === 'rejected' && <div className="supplier-tags__status rejected">Rejected</div>}
            </div>
            <div className="supplier__row">
                <div className="supplier__wrap first">
                    <div className="supplier__title">
                        ({elem.name_prefix}) {elem.name}
                    </div>
                    <div className="supplier__subtitle">{elem.trading_name}</div>
                </div>
                {elem.manager_name ? (
                    <div className="supplier__wrap">
                        <div className="supplier__title">{elem.manager_name ? elem.manager_name : ''}</div>
                        <div className="supplier__subtitle">
                            {elem?.email ? elem?.email : ''} {elem?.phone_number ? elem?.phone_number : ''}
                        </div>
                    </div>
                ) : (
                    <div className="supplier__wrap"></div>
                )}

                {elem.manager_name && (
                    <img
                        src={editIcon}
                        className="supplier__delete"
                        onClick={() => {
                            setTaskId(elem.id);
                            setSupplierData({
                                manager: {
                                    name: elem.manager_name,
                                    email: elem.email,
                                    phone_number: elem.phone_number
                                },
                                company: {
                                    name: elem.name
                                },
                                id: elem.id
                            });
                            setIsEditModal(true);
                        }}
                    />
                )}
            </div>
            {elem.status === 'rejected' &&
                (elem?.comments?.su_rejected_comment || elem?.comments?.su_rejected_category_name) && (
                    <>
                        <Divider className="supplier-card-tr__rejection-divider" />
                        <div className="supplier-card-tr__rejection">
                            <img src={messageGrey} alt="" className="supplier-card-tr__rejection-icon" />
                            <span className="supplier-card-tr__rejection-text">
                                {elem.comments.su_rejected_comment
                                    ? elem.comments.su_rejected_comment
                                    : elem.comments.su_rejected_category_name}
                            </span>
                        </div>
                    </>
                )}
        </div>
    );
};
